document.addEventListener("DOMContentLoaded", function () {

  const DESKTOP4_PORTRAIT_STORAGE_KEY = 'desktop4-portrait-accepted';

  function isDesktop4Page() {
    return document.documentElement.classList.contains('desktop4-scaled-page');
  }

  function isTouchViewport() {
    const hasCoarsePointer = window.matchMedia?.('(any-pointer: coarse)').matches ||
      window.matchMedia?.('(pointer: coarse)').matches;
    const hasTouchPoints = navigator.maxTouchPoints > 0;
    return hasCoarsePointer || hasTouchPoints;
  }

  function isPortraitOrientation() {
    const orientationType = window.screen?.orientation?.type;
    if (orientationType) {
      return orientationType.startsWith('portrait');
    }
    if (window.matchMedia) {
      return window.matchMedia('(orientation: portrait)').matches;
    }
    return window.innerHeight >= window.innerWidth;
  }

  function hasAcceptedPortraitMode() {
    if (isDesktop4Page() && isTouchViewport()) {
      return true;
    }

    try {
      return sessionStorage.getItem(DESKTOP4_PORTRAIT_STORAGE_KEY) === '1';
    } catch (_) {
      return document.documentElement.classList.contains('desktop4-portrait-accepted');
    }
  }

  function setPortraitAccepted(accepted) {
    const root = document.documentElement;
    if (accepted) {
      root.classList.add('desktop4-portrait-accepted');
      try {
        sessionStorage.setItem(DESKTOP4_PORTRAIT_STORAGE_KEY, '1');
      } catch (_) { }
      return;
    }
    root.classList.remove('desktop4-portrait-accepted');
    try {
      sessionStorage.removeItem(DESKTOP4_PORTRAIT_STORAGE_KEY);
    } catch (_) { }
  }

  function shouldShowDesktop4RotatePrompt() {
    return isDesktop4Page() && isTouchViewport() && isPortraitOrientation() && !hasAcceptedPortraitMode();
  }

  function syncDesktop4PortraitAcceptedClass() {
    if (!isDesktop4Page()) {
      return;
    }
    document.documentElement.classList.toggle('desktop4-portrait-accepted', hasAcceptedPortraitMode());
  }

  function checkMobileWarning() {
    const mobileWarningPopup = document.getElementById('mobile-warning-popup');
    if (!mobileWarningPopup) {
      return;
    }

    if (isDesktop4Page()) {
      syncDesktop4PortraitAcceptedClass();
      mobileWarningPopup.classList.toggle('show', shouldShowDesktop4RotatePrompt());
      return;
    }

    const isMobileDevice = /Android|webOS|iPhone|iPad|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768;

    if (isMobileDevice && !mobileWarningPopup.classList.contains('closed-by-user')) {
      mobileWarningPopup.classList.add('show');
    } else if (!isMobileDevice) {
      mobileWarningPopup.classList.remove('show');
    }
  }

  if (isDesktop4Page()) {
    syncDesktop4PortraitAcceptedClass();
  }

  checkMobileWarning();
  window.addEventListener('resize', checkMobileWarning);
  window.addEventListener('orientationchange', checkMobileWarning);
  if (window.screen?.orientation?.addEventListener) {
    window.screen.orientation.addEventListener('change', checkMobileWarning);
  }

  const mobileWarningPopup = document.getElementById('mobile-warning-popup');
  const continuePortraitBtn = document.getElementById('continue-in-portrait-btn');
  const closeMobileWarningBtn = document.getElementById('close-mobile-warning-pop-up');

  if (continuePortraitBtn && mobileWarningPopup) {
    continuePortraitBtn.addEventListener('click', () => {
      setPortraitAccepted(true);
      mobileWarningPopup.classList.remove('show');
      checkMobileWarning();
      applyDesktop4HeaderLayout();
      window.StockStormDesktop4Scale?.apply?.({ force: true });
    });
  }

  const headerAnchors = { menuPrev: null, menuParent: null, actionsPrev: null, actionsParent: null };

  function setDesktop4BurgerOpen(open) {
    document.documentElement.classList.toggle('desktop4-burger-open', !!open);
    const burgerBtn = document.querySelector('.desktop4-burger-toggle');
    burgerBtn?.setAttribute('aria-expanded', String(!!open));
  }

  function ensureDesktop4BurgerToggle() {
    if (!isDesktop4Page()) {
      return null;
    }
    const topbar = document.querySelector('#main-header .ss-topbar');
    if (!topbar) {
      return null;
    }
    let burgerBtn = topbar.querySelector(':scope > .desktop4-burger-toggle');
    if (burgerBtn) {
      return burgerBtn;
    }

    burgerBtn = document.createElement('button');
    burgerBtn.type = 'button';
    burgerBtn.className = 'desktop4-burger-toggle';
    burgerBtn.setAttribute('aria-label', 'Toggle menu');
    burgerBtn.setAttribute('aria-expanded', 'false');
    burgerBtn.innerHTML = '<span></span><span></span><span></span>';
    topbar.appendChild(burgerBtn);

    burgerBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = document.documentElement.classList.contains('desktop4-burger-open');
      setDesktop4BurgerOpen(!isOpen);
    });

    return burgerBtn;
  }

  function rememberHeaderAnchors() {
    const topbar = document.querySelector('#main-header .ss-topbar');
    if (!topbar || headerAnchors.menuParent) {
      return;
    }
    const menu = topbar.querySelector(':scope > .ss-menu');
    const actions = topbar.querySelector(':scope > .ss-actions');
    if (menu) {
      headerAnchors.menuParent = menu.parentNode;
      headerAnchors.menuPrev = menu.previousElementSibling;
    }
    if (actions) {
      headerAnchors.actionsParent = actions.parentNode;
      headerAnchors.actionsPrev = actions.previousElementSibling;
    }
  }

  function ensureDropdownCloseButton(dropdown) {
    let closeBtn = dropdown.querySelector(':scope > .desktop4-burger-close');
    if (closeBtn) {
      return closeBtn;
    }
    closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'desktop4-burger-close';
    closeBtn.setAttribute('aria-label', 'Close menu');
    closeBtn.innerHTML = '<span></span><span></span>';
    closeBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      setDesktop4BurgerOpen(false);
    });
    return closeBtn;
  }

  function moveIntoDropdown() {
    const topbar = document.querySelector('#main-header .ss-topbar');
    if (!topbar) {
      return;
    }
    let dropdown = topbar.querySelector(':scope > .desktop4-burger-dropdown');
    if (!dropdown) {
      dropdown = document.createElement('div');
      dropdown.className = 'desktop4-burger-dropdown';
      topbar.appendChild(dropdown);
    }
    const menu = document.querySelector('#main-header .ss-menu');
    const actions = document.querySelector('#main-header .ss-actions');

    if (menu && menu.parentNode !== dropdown) {
      const allLinks = Array.from(menu.querySelectorAll(':scope > .ss-link'));
      const activeLinks = allLinks.filter(l => !l.classList.contains('disabled'));
      const disabledLinks = allLinks.filter(l => l.classList.contains('disabled'));

      activeLinks.forEach(link => {
        if (link.parentNode !== dropdown) {
          dropdown.appendChild(link);
        }
      });

      dropdown.appendChild(menu);

      if (actions && actions.parentNode !== dropdown) {
        dropdown.appendChild(actions);
      }

      let disabledGrid = dropdown.querySelector(':scope > .desktop4-burger-disabled-grid');
      if (!disabledGrid) {
        disabledGrid = document.createElement('div');
        disabledGrid.className = 'desktop4-burger-disabled-grid';
        dropdown.appendChild(disabledGrid);
      }
      disabledLinks.forEach(link => {
        if (link.parentNode !== disabledGrid) {
          if (!link.querySelector('.coming-soon-label')) {
            const label = document.createElement('span');
            label.className = 'coming-soon-label';
            label.textContent = 'Coming soon';
            link.appendChild(label);
          }
          disabledGrid.appendChild(link);
        }
      });
    } else {
      if (actions && actions.parentNode !== dropdown) {
        dropdown.appendChild(actions);
      }
      const disabledGrid = dropdown.querySelector(':scope > .desktop4-burger-disabled-grid');
      if (disabledGrid) {
        dropdown.appendChild(disabledGrid);
      }
    }
  }

  function restoreHeaderLayout() {
    const topbar = document.querySelector('#main-header .ss-topbar');
    if (!topbar) {
      return;
    }
    const menu = topbar.querySelector('.ss-menu');
    const actions = topbar.querySelector('.ss-actions');

    const disabledGrid = topbar.querySelector('.desktop4-burger-disabled-grid');
    if (disabledGrid && menu) {
      Array.from(disabledGrid.querySelectorAll('.ss-link')).forEach(link => {
        const label = link.querySelector('.coming-soon-label');
        if (label) {
          label.remove();
        }
        menu.appendChild(link);
      });
      disabledGrid.remove();
    }

    const dropdown = topbar.querySelector(':scope > .desktop4-burger-dropdown');
    if (dropdown && menu) {
      Array.from(dropdown.querySelectorAll(':scope > .ss-link')).forEach(link => {
        menu.appendChild(link);
      });
    }

    if (menu && headerAnchors.menuParent && menu.parentNode !== headerAnchors.menuParent) {
      if (headerAnchors.menuPrev && headerAnchors.menuPrev.parentNode === headerAnchors.menuParent) {
        headerAnchors.menuPrev.after(menu);
      } else {
        headerAnchors.menuParent.prepend(menu);
      }
    }
    if (actions && headerAnchors.actionsParent && actions.parentNode !== headerAnchors.actionsParent) {
      if (headerAnchors.actionsPrev && headerAnchors.actionsPrev.parentNode === headerAnchors.actionsParent) {
        headerAnchors.actionsPrev.after(actions);
      } else {
        headerAnchors.actionsParent.appendChild(actions);
      }
    }
    if (dropdown && !dropdown.querySelector('.ss-menu, .ss-actions')) {
      dropdown.remove();
    }
  }

  function applyDesktop4HeaderLayout() {
    if (!isDesktop4Page()) {
      return;
    }
    rememberHeaderAnchors();
    const usePortraitLayout = hasAcceptedPortraitMode() && isPortraitOrientation();
    if (usePortraitLayout) {
      ensureDesktop4BurgerToggle();
      moveIntoDropdown();
    } else {
      restoreHeaderLayout();
      setDesktop4BurgerOpen(false);
    }
  }

  document.addEventListener('click', (e) => {
    if (!document.documentElement.classList.contains('desktop4-burger-open')) {
      return;
    }
    const burgerBtn = document.querySelector('.desktop4-burger-toggle');
    if (burgerBtn && (e.target === burgerBtn || burgerBtn.contains(e.target))) {
      return;
    }
    const dropdown = document.querySelector('#main-header .desktop4-burger-dropdown');
    if (dropdown && dropdown.contains(e.target)) {
      if (e.target.closest('.ss-link') || e.target.closest('.ss-pill-btn')) {
        setDesktop4BurgerOpen(false);
      }
      return;
    }
    setDesktop4BurgerOpen(false);
  });

  function handleBurgerScrollAttempt(e) {
    if (!document.documentElement.classList.contains('desktop4-burger-open')) {
      return;
    }
    const dropdown = document.querySelector('#main-header .desktop4-burger-dropdown');
    if (dropdown && dropdown.contains(e.target)) {
      return;
    }
    if (e.cancelable) {
      e.preventDefault();
    }
    setDesktop4BurgerOpen(false);
  }

  window.addEventListener('wheel', handleBurgerScrollAttempt, { passive: false });
  window.addEventListener('touchmove', handleBurgerScrollAttempt, { passive: false });

  if (isDesktop4Page()) {
    rememberHeaderAnchors();
    applyDesktop4HeaderLayout();
  }

  function refreshDesktop4OnOrientation() {
    setDesktop4BurgerOpen(false);
    applyDesktop4HeaderLayout();
    [200, 500].forEach((delay) => {
      window.setTimeout(applyDesktop4HeaderLayout, delay);
      window.setTimeout(() => { if (typeof applyChartPanelLayout === 'function') applyChartPanelLayout(); }, delay + 10);
    });
  }

  window.addEventListener('resize', applyDesktop4HeaderLayout);
  window.addEventListener('orientationchange', refreshDesktop4OnOrientation);
  if (window.screen?.orientation?.addEventListener) {
    window.screen.orientation.addEventListener('change', refreshDesktop4OnOrientation);
  }

  if (closeMobileWarningBtn && mobileWarningPopup && !isDesktop4Page()) {
    closeMobileWarningBtn.addEventListener('click', () => {
      mobileWarningPopup.classList.remove('show');
      mobileWarningPopup.classList.add('closed-by-user');
    });
  }

  const threeDChartBtn = Array.from(document.querySelectorAll('.ss-menu .ss-link')).find(el => el.textContent.trim() === '3D Chart');

  function exitSpecialMode(triggerFilter = false, exitWatchlist = true) {
    const isWatchlistMode = document.body.classList.contains('watchlist-mode');
    const centerChartOverlay = document.getElementById('center-chart-overlay');
    const isSearchMode = !!centerChartOverlay;

    if (isSearchMode) {
      const event = new CustomEvent('close-search-screen');
      document.dispatchEvent(event);
    }

    if (exitWatchlist && isWatchlistMode) {
      if (window.WatchlistApp && window.WatchlistApp.Manager) {
        window.WatchlistApp.Manager.exitWatchlistMode();
      }
    }

    if (triggerFilter) {
      const defaultChartBtn = document.querySelector('.filters-container .item[data-action="topdollar"]');
      if (defaultChartBtn) {
        defaultChartBtn.click();
      } else {
        console.warn('[Script] Top $ Volume filter button not found.');
      }
    }
  }

  if (threeDChartBtn) {
    threeDChartBtn.addEventListener('click', (e) => {
      e.preventDefault();

      const stockChart = document.getElementById('stock-chart');
      if (stockChart) {
        stockChart.setAttribute('tradingview-universal-chart', {
          secondarySeriesType: 'volume',
          stockData: JSON.stringify({
            ticker: "SPY",
            todaysChangePerc: 0.5,
            day: { c: 20000, v: 1000000 },
            tickerDetails: {
              name: "SPDR S&P 500 ETF Trust",
              primary_exchange: "NYSE"
            }
          }),
          dataInterval: '1d'
        });
      }

      exitSpecialMode(true, true);

      const generalNewsBtn = document.querySelector('.variant[data-filter="general"]');
      if (generalNewsBtn) {
        generalNewsBtn.click();
      }
    });
  }

  const chartPanel = document.getElementById('desktop4-chart-panel');
  const chartPanelToggle = document.getElementById('desktop4-chart-panel-toggle');
  const chartPanelBody = document.getElementById('desktop4-chart-panel-body');

  const controlsAnchors = {
    mainControlsParent: null,
    mainControlsPrev: null,
    playerParent: null,
    playerPrev: null,
    bannerSlotLeftParent: null,
    bannerSlotLeftPrev: null
  };

  function rememberControlsAnchors() {
    if (controlsAnchors.mainControlsParent) return;
    const mainControls = document.querySelector('#main-block .content-row .main-controls');
    const bottomPlayer = document.querySelector('#main-block > .bottom-player-area');
    const bannerSlotLeft = document.getElementById('banner-slot-left');
    if (mainControls) {
      controlsAnchors.mainControlsParent = mainControls.parentNode;
      controlsAnchors.mainControlsPrev = mainControls.previousElementSibling;
    }
    if (bottomPlayer) {
      controlsAnchors.playerParent = bottomPlayer.parentNode;
      controlsAnchors.playerPrev = bottomPlayer.previousElementSibling;
    }
    if (bannerSlotLeft) {
      controlsAnchors.bannerSlotLeftParent = bannerSlotLeft.parentNode;
      controlsAnchors.bannerSlotLeftPrev = bannerSlotLeft.previousElementSibling;
    }
  }

  function moveControlsIntoPanel() {
    if (!chartPanel || !chartPanelBody) return;

    let inner = chartPanelBody.querySelector('.desktop4-chart-panel-inner');
    if (!inner) {
      inner = document.createElement('div');
      inner.className = 'desktop4-chart-panel-inner';
      chartPanelBody.appendChild(inner);
    }

    const mainControls = document.querySelector('#main-block .main-controls');
    const bottomPlayer = document.querySelector('#main-block .bottom-player-area');

    if (mainControls && mainControls.parentNode !== inner) {
      inner.appendChild(mainControls);
    }
    if (bottomPlayer && bottomPlayer.parentNode !== inner) {
      inner.appendChild(bottomPlayer);
    }

    const mainContainer = document.getElementById('main-container');
    const bannerSlotLeft = document.getElementById('banner-slot-left');
    if (mainContainer && bannerSlotLeft && bannerSlotLeft.parentNode !== mainContainer) {
      mainContainer.appendChild(bannerSlotLeft);
    }
  }

  function restoreControlsFromPanel() {
    if (!chartPanel) return;

    const mainControls = chartPanel.querySelector('.main-controls');
    const bottomPlayer = chartPanel.querySelector('.bottom-player-area');

    if (mainControls && controlsAnchors.mainControlsParent) {
      const prev = controlsAnchors.mainControlsPrev;
      if (prev && prev.parentNode === controlsAnchors.mainControlsParent) {
        prev.after(mainControls);
      } else {
        controlsAnchors.mainControlsParent.appendChild(mainControls);
      }
    }
    if (bottomPlayer && controlsAnchors.playerParent) {
      const prev = controlsAnchors.playerPrev;
      if (prev && prev.parentNode === controlsAnchors.playerParent) {
        prev.after(bottomPlayer);
      } else {
        controlsAnchors.playerParent.appendChild(bottomPlayer);
      }
    }

    const bannerSlotLeft = document.getElementById('banner-slot-left');
    if (bannerSlotLeft && controlsAnchors.bannerSlotLeftParent) {
      const prev = controlsAnchors.bannerSlotLeftPrev;
      if (prev && prev.parentNode === controlsAnchors.bannerSlotLeftParent) {
        prev.after(bannerSlotLeft);
      } else {
        controlsAnchors.bannerSlotLeftParent.appendChild(bannerSlotLeft);
      }
    }
  }

  function applyChartPanelLayout() {
    if (!isDesktop4Page() || !chartPanel) return;
    const usePortrait = hasAcceptedPortraitMode() && isPortraitOrientation();
    if (usePortrait) {
      rememberControlsAnchors();
      moveControlsIntoPanel();
    } else {
      restoreControlsFromPanel();
      chartPanel.classList.remove('is-open');
      if (chartPanelToggle) chartPanelToggle.setAttribute('aria-expanded', 'false');
    }
  }

  if (chartPanelToggle && chartPanel) {
    chartPanelToggle.addEventListener('click', () => {
      const isOpen = chartPanel.classList.toggle('is-open');
      chartPanelToggle.setAttribute('aria-expanded', String(isOpen));
    });
  }

  const _origApply = applyDesktop4HeaderLayout;
  function applyAllPortraitLayouts() {
    _origApply();
    applyChartPanelLayout();
  }

  window.removeEventListener('resize', applyDesktop4HeaderLayout);
  window.addEventListener('resize', applyAllPortraitLayouts);
  window.addEventListener('orientationchange', applyAllPortraitLayouts);
  if (window.screen?.orientation?.addEventListener) {
    window.screen.orientation.addEventListener('change', applyAllPortraitLayouts);
  }

  if (isDesktop4Page()) {
    applyChartPanelLayout();
  }
})